'use client';

import { c as _c } from "react/compiler-runtime";
import type { Subscription } from '@algoacademy/backend/modules/marketplace/enums';
import type { IndividualMentoringProductDTO } from '@algoacademy/backend/modules/payment/endpoints/mutations/stripe-checkout/input.dto/input.dto';
import type { Dispatch, SetStateAction } from 'react';
import { useUpdateMentoringProductOnTabChange } from './_hooks/updateMentoringProductOnTabChange';
import { HoursWithMentor } from './_sections/HoursWithMentor';
type IndividualMentoringManagerProps = {
  activeSubscriptionTab: Subscription;
  individualMentoringProduct: IndividualMentoringProductDTO;
  setIndividualMentoringProduct: Dispatch<SetStateAction<IndividualMentoringProductDTO>>;
};
export function IndividualMentoringManager(t0) {
  const $ = _c(9);
  const {
    activeSubscriptionTab,
    individualMentoringProduct,
    setIndividualMentoringProduct
  } = t0;
  let t1;
  if ($[0] !== activeSubscriptionTab || $[1] !== individualMentoringProduct || $[2] !== setIndividualMentoringProduct) {
    t1 = {
      mentoringProduct: individualMentoringProduct,
      subscription: activeSubscriptionTab,
      setMentoringProduct: setIndividualMentoringProduct
    };
    $[0] = activeSubscriptionTab;
    $[1] = individualMentoringProduct;
    $[2] = setIndividualMentoringProduct;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  useUpdateMentoringProductOnTabChange(t1);
  let t2;
  if ($[4] !== setIndividualMentoringProduct) {
    t2 = updates => {
      setIndividualMentoringProduct(prev => {
        const newUpdates = typeof updates === "function" ? updates(prev) : updates;
        return {
          ...prev,
          ...newUpdates
        };
      });
    };
    $[4] = setIndividualMentoringProduct;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const updateProduct = t2;
  let t3;
  if ($[6] !== individualMentoringProduct || $[7] !== updateProduct) {
    t3 = <div className="space-y-8"><HoursWithMentor individualMentoringProduct={individualMentoringProduct} updateProduct={updateProduct} /></div>;
    $[6] = individualMentoringProduct;
    $[7] = updateProduct;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}